<nz-spin nzTip="Loading..." [nzSpinning]="loading$ | async">
    <ng-container *ngIf="!(loading$ | async) && showNoScheduleLinkedError; else scheduleTemplate">
        <nz-alert
            nzType="warning"
            nzMessage="You don't have a schedule linked in CRM"
        ></nz-alert>
    </ng-container>
    <ng-template #scheduleTemplate>
        <form nz-form [nzLayout]="'inline'" *ngIf="schedule">
            <!-- Start -->
            <nz-form-item>
                <nz-form-label nzRequired>Start After</nz-form-label>
                <nz-form-control
                    [nzValidateStatus]="errors.startDate"
                    nzErrorTip="Required"
                >
                    <nz-input-group>
                        <nz-date-picker
                            name="startDate"
                            required
                            [(ngModel)]="schedule.startDate"
                        ></nz-date-picker>
                    </nz-input-group>
                </nz-form-control>
            </nz-form-item>

            <!-- End -->
            <nz-form-item>
                <nz-form-label nzRequired>End On</nz-form-label>
                <nz-form-control
                    [nzValidateStatus]="errors.endDate"
                    nzErrorTip="Required"
                >
                    <nz-input-group>
                        <nz-date-picker
                            name="endDate"
                            required
                            [(ngModel)]="schedule.endDate"
                        ></nz-date-picker>
                    </nz-input-group>
                </nz-form-control>
            </nz-form-item>
            <!-- spacer -->
            <div style="flex: 1"></div>

            <button nz-button [nzType]="'primary'" (click)="save()">
                Save
            </button>
        </form>
        <div *ngIf="schedule">
            <br />
            <!-- Name -->
            <p>Link your calendar</p>
            <div style="display: flex; gap: 1rem">
                <nz-form-item style="flex: 1;">
                    <nz-form-label>ICS link</nz-form-label>
                    <nz-form-control>
                        <nz-input-group>
                            <input
                                name="icsLink"
                                [ngModel]="icsLink"
                                (ngModelChange)="onChangeIcsLink($event)"
                                nz-input
                                placeholder="ICS link"
                            />
                        </nz-input-group>
                    </nz-form-control>
                </nz-form-item>
                <button
                    nz-button
                    (click)="sync()"
                    *ngIf="icsLink && !isICSdirty"
                >Sync now</button>
            </div>
        </div>

        <div style="display: flex; align-items: center; gap: 1rem;">
            <h3 style="margin: 0;">
                Availability Calendar
            </h3>
            <sub style="font-weight: bold; color: #e52727;">Times Are Shown in {{ timezone }} Timezone (Your local timezone)</sub>
        </div>

        <app-schedule-calendar
            [schedule]="schedule"
            (slotAdded)="slotAddedHandler($event)"
            (slotUpdated)="slotUpdatedHandler($event)"
            (slotDeleted)="slotDeletedHandler($event)"
            (overrideAdded)="overrideAddedHandler($event)"
            (overrideUpdated)="overrideUpdatedHandler($event)"
            (overrideDeleted)="overrideDeletedHandler($event)"
        ></app-schedule-calendar>
        
    </ng-template>
</nz-spin>
